import RegisterUserStore from './registerUserStore'
import LoginStore from './loginStore'
import ConfirmUserStore from './confirmUserStore'
import UserStore from './userStore'
import ProductsStore from './productsStore'
import UiStore from './uiStore'
import ForgotPasswordStore from './forgotPasswordStore'
import GenerateTokenStore from './generateTokenStore'
import NotificationStore from './notificationStore'
import CompaniesStore from './companiesStore'
import RequestsStore from './requestsStore'
import ProfilesStore from './profilesStore'
import SendMailStore from './sendMailStore'

import NfeStore from './products/nfeStore'
import NfsStore from './products/nfsStore'
import ReinfStore from './products/reinfStore'

import ConfigUsersStore from './config/configUsersStore'
import ConfigGroupsStore from './config/configGroupsStore'
import CompanyProductStore from './config/companyProductStore'
import ConfigCompaniesStore from './config/companies/configCompaniesStore'
import EditReinfStore from './config/companies/products/editReinfStore'
import EditNfeStore from './config/companies/products/editNfeStore'

class RootStore {
  constructor () {
    this.stores = {}
    this.stores.notificationStore = new NotificationStore()
    this.stores.registerUserStore = new RegisterUserStore(this)
    this.stores.userStore = new UserStore(this)
    this.stores.loginStore = new LoginStore(this)
    this.stores.uiStore = new UiStore()
    this.stores.nfeStore = new NfeStore(this)
    this.stores.productsStore = new ProductsStore()
    this.stores.companiesStore = new CompaniesStore()
    this.stores.confirmUserStore = new ConfirmUserStore(this)
    this.stores.forgotPasswordStore = new ForgotPasswordStore(this)
    this.stores.generateTokenStore = new GenerateTokenStore(this)
    this.stores.requestsStore = new RequestsStore(this)
    this.stores.reinfStore = new ReinfStore(this)
    this.stores.configUsersStore = new ConfigUsersStore()
    this.stores.profilesStore = new ProfilesStore()
    this.stores.configCompaniesStore = new ConfigCompaniesStore(this)
    this.stores.configGroupsStore = new ConfigGroupsStore(this)
    this.stores.editReinfStore = new EditReinfStore(this)
    this.stores.editNfeStore = new EditNfeStore()
    this.stores.companyProductStore = new CompanyProductStore(this)
    this.stores.sendMailStore = new SendMailStore(this)
    this.stores.nfsStore = new NfsStore(this)
  }
}

export default new RootStore()



// WEBPACK FOOTER //
// ./src/stores/rootStore.js